export default __webpack_public_path__ + "static/media/DNSH.2e21b2f9.svg";